// ======================================================================
// File Name       : EachQuestionAttributeListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, isInvalid, getFormValues, change, formValueSelector } from 'redux-form';
import { Form, Button, Col, Table } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { parseDateForDetail } from '../../utils/index';
import { DEFAULT_DATE_FORMAT, SELECT_TARGET_DATA, RETURN_MAX_NUM } from '../../constants/index';
import ReduxFormPaging from '../../components/ReduxFormPaging';
import RenderField from '../../utils/ReduxFormUtils';
import * as ContentQuestionAction from '../../actions/content/ContentQuestionAction';
import MessageSearch from '../../components/MessageSearch';
import Header from '../../components/Header';
import CustomButton from '../../components/button/CustomButton';

class EachQuestionAttributeListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      isAllowShowSearchMessage: false,
    };
    this.createParams = this.createParams.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(ContentQuestionAction.getAttributeQuestionList());
  }

  handleChangeOption(value) {
    if (!value) {
      this.props.change('eachQuestionAttributeName', '');
    }
  }

  createParams(data) {
    const param = {};
    if (data && data.questionAttributeId) {
      param.questionAttributeIdList = [data.questionAttributeId];
    }
    if (data && data.eachQuestionAttributeName && data.questionAttributeId) {
      param.eachQuestionAttributeName = data.eachQuestionAttributeName;
    }
    param.selectTargetData = SELECT_TARGET_DATA.DATA;
    return param;
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      ...this.state.filterData,
      eachQuestionAttributeName: formValues.eachQuestionAttributeName,
      questionAttributeId: formValues.questionAttributeId,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(filterData);
      this.props
        .dispatch(ContentQuestionAction.searchQuestionAttributeList(paramSearch))
        .then(() => {
          this.setState({ isAllowShowSearchMessage: true });
        });
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const { attributeListDataDialog, formValues, attributeListData } = this.props;
    const { recordNum } = attributeListDataDialog;
    const thead = [
      { title: '個別問題属性ID', sortBy: null },
      { title: '個別問題属性名', sortBy: null },
    ];
    const { eachQuestionAttributeList } = attributeListDataDialog;
    const data = [{ name: null, value: null }];
    if (
      attributeListData &&
      attributeListData.allSecernIds &&
      attributeListData.allSecernIds.length
    ) {
      attributeListData.allSecernIds.map((questionAttributeId, index) => {
        const bySecernIds = attributeListData.bySecernId[questionAttributeId];
        const { questionAttributeName } = bySecernIds;
        const questionAttributeNameAndId = `${questionAttributeName} (${questionAttributeId})`;
        data.push({ name: questionAttributeNameAndId, value: questionAttributeId });
      });
    }
    let isDisable = 1;
    if (formValues && formValues.questionAttributeId) {
      isDisable = 0;
    }
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={
            attributeListDataDialog ? attributeListDataDialog.eachQuestionAttributeList : []
          }
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="問題属性の検索" />
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={e => {
            e.preventDefault();
            this.clickSearchButton();
          }}
          className='form-horizontal'>
          <Form.Group className="form-info padding-left-15">
            <Col as={Form.Label} sm={4}>
              問題属性名(問題属性ID)
            </Col>
            <Col sm={7}>
              <RenderField
                type="selectbox"
                name="questionAttributeId"
                data={data}
                label="問題属性ID"
                handleChangeOption={this.handleChangeOption}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info padding-left-15">
            <Col as={Form.Label} sm={4}>
              個別問題属性名
            </Col>
            <Col sm={7}>
              <RenderField
                type="text"
                name="eachQuestionAttributeName"
                label="個別問題属性名"
              />
            </Col>
          </Form.Group>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="text-center margin-bottom-20">
              {/* <Button bsStyle="primary" className="btn-96" type="submit" disabled={isDisable}>
                search
              </Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                isDisabled={isDisable}
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Form>
        <Table striped hover>
          <thead>
            <ReduxFormPaging type="tableHead" name="questionAttributeSortType" data={thead} />
          </thead>
          <tbody>
            {eachQuestionAttributeList &&
              eachQuestionAttributeList.length ?
              eachQuestionAttributeList.map((eachQuestionAttribute, index) => {
                return (
                  <tr key={index}>
                    <td>{eachQuestionAttribute.eachQuestionAttributeId}</td>
                    <td>{eachQuestionAttribute.eachQuestionAttributeName}</td>
                  </tr>
                );
              }) : null}
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { attributeListDataDialog, attributeListData } = state.question;
  const invalid = isInvalid('attributeQuestionList')(state);
  const initial = {
    startPosition: 0,
  };
  return {
    initialValues: initial,
    attributeListDataDialog,
    attributeListData,
    invalid,
    formValues: getFormValues('attributeQuestionList')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'attributeQuestionList', // a unique identifier for this form
    touchOnChange: true,
  })(EachQuestionAttributeListContainer),
);
